<template>
  <div class="pratice-theme-esg-manisfest-content" id="identidade-verbal-na-pratica-manisfesto" data-search-anchor>
        <h1 class="pratice-theme-esg-manisfest-title">
          {{ praticeThemeEsgManifestTitle }}
        </h1>      

        <div class="pratice-colums-theme-esg-manisfest-wrapper">

            <div class="pratice-theme-esg-manisfest-container">
                <p class="pratice-manifest-paragraph-title">{{ praticeManifestParagraphTitle }}</p>
                <p class="pratice-manifest-paragraph">{{ praticeManifestParagraph1 }}</p>                        
                <p class="pratice-manifest-paragraph">{{ praticeManifestParagraph2 }}</p>                
                <p class="pratice-manifest-paragraph">{{ praticeManifestParagraph3 }}</p>                           
            </div>

            <div class="pratice-theme-esg-manisfest-tips-container">
                <p class="pratice-tips-paragraph-tilte">{{ praticeTipsParagraphTitle }}</p>
                <p class="pratice-tips-esg-paragraph">{{ praticeTipsParagraph1 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph2 }}</p>
                <TwoCircles />
                <p class="pratice-tips-esg-paragraph">{{ praticeTipsParagraph3 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph4 }}</p>
                <ThreeCircles />

                <div class="pratice-tips-esg-legend-wrapper">
                  <div class="pratices-tips-legend-paragraph">
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph5 }}</p>
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph6 }}</p>
                  </div>
                  
                  <div class="pratice-legend-circles">
                    <div class="pratice-line">
                      <LineGradient />
                    </div>
                    <div class="pratice-circles">
                      <ThreeCircles /><TwoCircles /><OneCircle /><BlankCircles />
                    </div>                   
                  </div>                  
                </div>           
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import BlankCircles from '@/assets/icons/BlankCircles.vue'
import LineGradient from '@/assets/icons/LineGradient.vue'
import OneCircle from '@/assets/icons/OneCircle.vue'
import ThreeCircles from '@/assets/icons/ThreeCircles.vue'
import TwoCircles from '@/assets/icons/TwoCircles.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { ThreeCircles, LineGradient, TwoCircles, OneCircle, BlankCircles }})
export default class PraticeThemeEsgManifestSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticeThemeEsgManifestTitle(): string {
    return this.getElementTitle(4, 0)
  }

  get praticeManifestParagraphTitle(): string {
    return this.getElementText(4, 0)
  }

  get praticeManifestParagraph1(): string {
    return this.getElementText(4, 1)
  }

  get praticeManifestParagraph2(): string {
    return this.getElementText(4, 2)
  }

  get praticeManifestParagraph3(): string {
    return this.getElementText(4, 3)
  }

  get praticeTipsParagraphTitle(): string {
    return this.getElementText(4, 4)
  }

  get praticeTipsParagraph1(): string {
    return this.getElementText(4, 5)
  }

  get praticeTipsParagraph2(): string {
    return this.getElementText(4, 6)
  }

  get praticeTipsParagraph3(): string {
    return this.getElementText(4, 7)
  }

  get praticeTipsParagraph4(): string {
    return this.getElementText(4, 8)
  }

  get praticeTipsParagraph5(): string {
    return this.getElementText(4, 9)
  }

  get praticeTipsParagraph6(): string {
    return this.getElementText(4, 10)
  }

  async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.pratice-theme-esg-manisfest-content {
  display: grid;
  justify-content: center;
  margin-top: 80px;  
  max-width: 1032px;
}

.pratice-theme-esg-manisfest-title {
  font-size: 32px;
  font-weight: 400;
  line-height: 36px;
  text-align: left;
  margin: 0;
  width: 100%;
}

.pratice-colums-theme-esg-manisfest-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 495px);
  gap: 42px;
}

.pratice-theme-esg-manisfest-container {
  width: 506px;
  height: 565px;
  border-radius: 16px;
  margin-top: 50px;
  color: white;
  background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
}

.pratice-theme-esg-manisfest-tips-container {
  width: 506px;
  height: 565px;  
  margin-top: 50px;
}

.pratice-manifest-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;  
  margin:0 31px 22px 33px;
}

.pratice-manifest-paragraph:last-of-type{
  white-space: pre;
}

.pratice-manifest-paragraph-title {
  font-weight: 700;
  font-size: 20px;  
  line-height: 24px;
  margin:31px 0 35px 29px;
  white-space: pre;
  
}

.pratice-tips-paragraph-tilte {
  font-weight: 800;
  font-size: 20px;  
  line-height: 17px;
  margin-top: 31px;
  margin-bottom: 49px;
  white-space: pre;  
}

.pratice-tips-esg-paragraph {
  font-weight: 400;
  font-size: 16px;  
  line-height: 24px;
  margin-bottom: 0; 
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-esg-paragraph:nth-child(5) {
  margin-top: 74px;
}

.pratice-tips-bold-paragraph{
  font-weight: 800;
  margin: 0;
}

.pratice-tips-esg-legend-wrapper {
  display: flex;
  flex-direction: column;  
  margin-top: 92px;
}

.pratices-tips-legend-paragraph {
  display: flex;
  gap: 118px;              
}

.pratices-legend-paragraph {
  display: flex;
  font-weight: 600;
  font-size: 16px;  
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 7px;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-circles {
  display: flex;
  flex-direction: column;
  gap: 12px;  
}

.pratice-circles{
  display: flex;
  gap: 74px;
}

</style>
